module.exports = __webpack_public_path__ + "static/media/polygon.c6a749d0.svg";